import React from 'react';
import { useNetworkStatus } from "../context/Network";

const OfflineIndicator = () => {
    const { isOnline } = useNetworkStatus();

    if (isOnline) {
        return null; // Don't render anything if online
    }

    // Basic styling for the indicator banner
    const indicatorStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        padding: '10px',
        backgroundColor: '#ff4d4f', // Red color for offline
        color: 'white',
        textAlign: 'center',
        zIndex: 10000, // Ensure it's on top of everything
    };

    return (
        <div style={indicatorStyle}>
            🔴 <b>You are currently offline.</b> Please check your internet connection.
        </div>
    );
};

export default OfflineIndicator;
